import { RequestContext, RequestError } from '../types';
const { retry }: any = require('@lifeomic/attempt/src/index.js');
/**
 * Options for fetching from accounts service using @lifeomic/attempt `retry`
 */
export const DEFAULT_RETRY_OPTIONS = {
  delay: 500,
  maxAttempts: 3,
  jitter: true,
  handleError(err: RequestError, context: RequestContext) {
    if (err.retryable === false) {
      context.abort();
    }
  },
};

/**
 * Make a request to a service running on AWS Lambda and retry when receiving
 * a 502 which sometimes happens when the lambda is not warm
 *
 * @param {Function} requestFn - Fetch function to make the request
 * @param {attempt.AttemptOptions} retryOptions - Options to
 * @lifeomic/attempt to retry the request. Defaults to `DEFAULT_RETRY_OPTIONS`
 */
export default async function retryIfTimeout(
  requestFn: () => Promise<Response>,
  retryOptions = DEFAULT_RETRY_OPTIONS,
  skipJson = false
) {
  const response = await retry(async (context: any) => {
    const response = await requestFn();

    if (response.status === 502) {
      throw new Error('Request timeout error');
    } else if (response.status >= 300) {
      const err = new Error('Received non-200 status code') as RequestError;
      err.retryable = false;
      throw err;
    }

    return response;
  }, retryOptions);

  return skipJson ? response : response.json();
}
